@use "~theme/breakpoints";
@use "~theme/typography";

.container {
  height: 100%;
  width: 100%;
  margin: auto;
  padding-top: 90px;
  padding-left: var(--mobile-gutter);
  padding-right: var(--mobile-gutter);
  text-align: center;

  @include breakpoints.desktop {
    padding-top: 169px;
    max-width: var(--mobile-width);
  }
}

.heading {
  @include typography.heading3;
  margin-top: 0;
  margin-bottom: 36px;
}

.message {
  margin-bottom: 48px;
}

.ctaWrapper {
  background-color: var(--white);
  padding: 16px 19px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  @include breakpoints.desktop {
    background-color: transparent;
    position: inherit;
  }
}
